import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import '../styles/BuyCoursePage.css';

const BuyCoursePage = ({ onClose, isAuthenticated }) => {
  const navigate = useNavigate();
  const { user } = useUser();

  if (!isAuthenticated) {
    onClose();
    navigate('/login');
    return null;
  }

  return (
    <div className="buy-course-container" style={{
      backgroundColor: 'rgba(0, 0, 0, 0.85)'
    }}>
      <div className="buy-course-content" style={{
        backgroundColor: '#1a1a1a',
        color: 'white'
      }}>
        <button className="close-button" onClick={onClose} style={{
          color: 'white',
          backgroundColor: 'transparent',
          border: '1px solid white'
        }}>×</button>
        <h2 style={{ color: 'white' }}>Buy Course Access</h2>
        <div className="price-info">
          <h3 style={{ color: '#ff4444' }}>Price: $189.00 USD</h3>
          <p style={{ color: 'white' }}>Get lifetime access to all course materials</p>
        </div>

        <div className="payment-methods" style={{
          backgroundColor: '#2d2d2d',
          padding: '20px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4 style={{ color: 'white', marginBottom: '15px' }}>Accepted Payment Methods:</h4>
          <ul style={{ 
            listStyle: 'none', 
            padding: 0,
            margin: 0,
            color: '#2196F3'
          }}>
            <li style={{ marginBottom: '10px' }}>• Bitcoin</li>
            <li style={{ marginBottom: '10px' }}>• Ethereum</li>
            <li style={{ marginBottom: '10px' }}>• USDC ERC20</li>
            <li style={{ marginBottom: '10px' }}>• Litecoin</li>
            <li style={{ marginBottom: '10px' }}>• Any crypto you want except USDT</li>
          </ul>
        </div>

        <div className="payment-instructions" style={{
          marginTop: '20px',
          padding: '20px',
          backgroundColor: '#2d2d2d',
          border: '1px solid #404040',
          borderRadius: '5px',
          fontSize: '0.9em',
          color: 'white'
        }}>
          <h4 style={{ color: 'white', marginBottom: '15px' }}>How to Purchase:</h4>
          <p style={{ marginBottom: '15px' }}>
            Payment is manual to avoid system abuse.
            To purchase course access, please contact via email:
          </p>
          <a 
            href="mailto:radioideaxp@gmail.com" 
            style={{
              color: '#2196F3',
              textDecoration: 'none',
              fontSize: '1.1em',
              fontWeight: 'bold'
            }}
          >
            radioideaxp@gmail.com
          </a>
          <p style={{ 
            marginTop: '15px',
            color: '#66bb6a',
            fontWeight: 'bold' 
          }}>
            Response time: Less than 24 hours
          </p>
          <p style={{ marginTop: '15px' }}>
            Please include your registered email ({user.primaryEmailAddress?.emailAddress}) in your message for faster verification.
            After you pay, your account will be activated and access granted.
            <br></br>
            If you have discount code, please include it in your message.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BuyCoursePage; 